import { FlexSpreadList } from "../components/Helper/HelperComponents";
import Settings from "../components/Settings/Settings";

const SettingsPage = () => {
  return (
    <FlexSpreadList>
      <Settings />
    </FlexSpreadList>
  );
};

export default SettingsPage;
